import launchpadItems from "../../common/consts/launchpadItems";
import retiringLaunchpadItems from "../../common/consts/retiringLaunchpadItems";
import RTKCard from "../../common/Cards/RTKCard";
import Breadcrumbs from "../../common/Breadcrumbs/Breadcrumbs.js";
import orderBy from "lodash.orderby";
import IfRole from "../../common/IfRole.js";
import LaunchpadStats from "./LaunchpadStats.js";
import Toast from "../../common/Cards/Toast.js";
import { auth, useAuth } from "../../scripts/app.js";
import { Button } from "@mui/material";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const legacy = false;
export default function Launchpad() {
  const { currentUserToken, loading } = useAuth();
  const nav = useNavigate();
  // console.log('token', currentUserToken)
  let pageBreadcrumbs = [
    { name: "Launchpad", href: "/main/launchpad", current: true },
  ];
  const roles = [
    // "executor",
    "viewer",
    "manager",
    "designer",
    "admin",
    "superuser",
  ];
  const index = roles.indexOf(currentUserToken.claims.role);

  const toastBody = (
    <div>
      <p className="pb-6">
        We've reorganised the Launchpad and created new ways to see your data
        and will be retiring older data views on 31st September 2025. See the
        "Soon to be retired" section.
      </p>
      <p className="pb-6">
        One of our customer service representatives will contact you to walk
        your account holder through the new screens, helping you to get the best
        from your data.
      </p>
    </div>
  );

  const handleLogout = () => {
		signOut(auth)
			.then(() => {
				// Sign-out successful.
				nav("/");
				console.log("Signed out successfully");
			})
			.catch((error) => {
				// An error happened.
			});
	};

  return (
    <>
      <Breadcrumbs breadcrumbs={pageBreadcrumbs} />
      {legacy && (
        <Toast accentColour={"#046087"} title="What's New" body={toastBody} />
      )}
      <div className="mx-auto">
        <h1>
          Statusboard<span className="tm">™</span> Launchpad
        </h1>
        <h3 className="sub-title">
          Realtime Knowledge<span className="tm">™</span> of your organisation's operation, made simple!
        </h3>

        <IfRole role="manager">
          <LaunchpadStats />
        </IfRole>

        {index !== -1 ? (
          <>
            <div className="px-4">
              <h4 className="mb-4 bg-gray-200 rounded-2xl size-auto py-2 px-4 border-gray-300 border-[1px]">
                DASHBOARDS
              </h4>
            </div>

            <ul className="launchpad cards" id="content">
              {orderBy(launchpadItems, "order", "asc").map((item) => {
                return (
                  <IfRole route={item.route} key={item.id}>
                    <RTKCard
                      {...item}
                      path={item.route}
                      id={item.id}
                      link={true}
                    />
                  </IfRole>
                );
              })}
            </ul>
            {legacy && (
              <>
                {" "}
                <div className="px-4">
                  <h4 className="mb-4 bg-gray-200 rounded-2xl size-auto py-2 px-4 border-gray-300 border-[1px]">
                    SOON TO BE RETIRED
                  </h4>
                </div>
                <ul className="launchpad cards" id="content">
                  {orderBy(retiringLaunchpadItems, "order", "asc").map(
                    (item) => {
                      return (
                        <IfRole role={item.requiredRole} key={item.id}>
                          <RTKCard
                            {...item}
                            path={item.route}
                            key={item.id}
                            link={true}
                          />
                        </IfRole>
                      );
                    }
                  )}
                </ul>
              </>
            )}
          </>
        ) : (
            <section className="flex flex-col items-center mb-[32px] bg-white rounded-xl overflow-hidden py-[32px] px-[32px] shadow-lg w-full md:w-[800px]">

              <div className="flex gap-[16px] w-full justify-start items-center mb-[32px]">
                  <div className="bg-sky-500 p-[8px] flex justify-center items-center rounded-[999px]">
                    <svg width="24px" height="24px"  viewBox="0 0 24 24"><title>security</title><path fill="#FFFFFF" d="M12,12H19C18.47,16.11 15.72,19.78 12,20.92V12H5V6.3L12,3.19M12,1L3,5V11C3,16.55 6.84,21.73 12,23C17.16,21.73 21,16.55 21,11V5L12,1Z" /></svg>
                  </div>

                  <h3 className="sub-title w-full text-left mb-[0px]">Insufficient Access Rights!</h3>
              </div>
              <p className="text-left text-[#4C4C4C] pb-[64px]">
                Sorry, you don’t have permission to view data in this account.
                Please contact your internal account manager to request access permissions.
                <br/>
                <br/>
                Once access has been granted you will need to log out and log in
                again to gain access.
              </p>
              <Button
                variant="contained"
                onClick={() => handleLogout()}
                sx={{
                  color: "white",
                  borderRadius: "3rem",
                  backgroundColor: "#0A9D03",
                  "&:hover": {
                    backgroundColor: "#15803d",
                  },
                }}
              >
                Log Out
              </Button>
            </section>
        )}
      </div>
    </>
  );
}
